var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('WidgetCard',{attrs:{"title":"Actor label usage","icon":"mdi-label"}},[_c('canvas',{ref:"canvas"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }